<template>
  <v-btn class="pl-2" fab outlined height="20" width="20" :loading="loading">
    <v-icon v-if="item.collecting == true" x-small class="mr-2" @click="stop()">mdi-stop</v-icon>
    <v-icon v-else x-small class="mr-2" @click="start()">mdi-play</v-icon>
  </v-btn>
</template>

<script>
import { api } from '@/api/common/instances';
import bus from '@/utils/bus';

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loading: false,
  }),
  methods: {
    async start() {
      const response = await this.exec('start');
      if (response.status == 200) bus.$emit('activated-collect', this.item);
    },
    async stop() {
      const response = await this.exec('stop');
      if (response.status == 200) bus.$emit('deactivated-collect', this.item);
    },
    async exec(type) {
      this.loading = true;
      const response = await api.post(`/preference/collectors/${this.item.systemId}/${this.item.stackType}/${type}`);
      this.loading = false;
      return response;
    },
  },
};
</script>

<style></style>
